export const clossModalById = async (id) =>{
    return await document.getElementById(id).click();
}
